import { put, takeLatest, select } from 'redux-saga/effects'
import { redirect } from 'redux-first-router'

import {
  getQuizPage,
  NEXT_PAGE,
  PREVIOUS_PAGE,
  NEXT_UNANSWERED,
  GMA_QUIZ,
  PERSONALITY_QUIZ,
  INTEREST_QUIZ,
  toPersonalityQuiz,
  toInterestQuiz,
  toGmaQuiz,
} from 'ducks/router'
import { getRespondent } from 'ducks/respondent'

function* pagingSaga() {
  yield takeLatest([NEXT_PAGE, PREVIOUS_PAGE, NEXT_UNANSWERED], changePage)
}

export function* changePage(action) {
  const { type, page, uuid } = yield select(getQuizPage)
  const actionPayload = { uuid, page, reversed: action.type === PREVIOUS_PAGE }
  let length = 1
  let nextQuestion = (x: number) => x
  let actionCreator:
    typeof toGmaQuiz | typeof toPersonalityQuiz | typeof toInterestQuiz
  const { gma, personality, interest, stats } = yield select(getRespondent)
  switch (type) {
    case GMA_QUIZ: {
      nextQuestion = getFirstUnansweredGMA(gma)
      length = stats.gma.totalQuestions
      actionCreator = toGmaQuiz
      break
    }
    case PERSONALITY_QUIZ: {
      nextQuestion = getFirstUnansweredPersonality(personality)
      length = stats.personality.totalQuestions
      actionCreator = toPersonalityQuiz
      break
    }
    case INTEREST_QUIZ: {
      nextQuestion = getFirstUnansweredInterest(interest)
      length =
        interest.questions?.length ||
        interest.instruments?.questions?.length ||
        stats.interest.totalQuestions ||
        1
      actionCreator = toInterestQuiz
      break
    }
    default:
      console.error(`unknown section ${type}`)
      return
  }
  const pagerMap = {
    [NEXT_PAGE]: (x: number) => x + 1,
    [PREVIOUS_PAGE]: (x: number) => x - 1,
    [NEXT_UNANSWERED]: nextQuestion,
  }
  const nextPage = pagerMap[action.type] ?? ((x: number) => x)

  actionPayload.page = wrapIndex(length)(nextPage(page))
  const routeAction = actionCreator(actionPayload)
  yield put(redirect(routeAction))
}

// non-negative, unlike %
const wrapIndex = length => idx => ((idx % length) + length) % length

const rotate = (n, xs) => {
  const idx = n % xs.length
  return xs.slice(idx).concat(xs.slice(0, idx))
}

const getFirstUnansweredGMA =
  ({ answers }) =>
  page => {
    const index = rotate(page + 1, Object.values(answers)).findIndex(
      answer => answer == null,
    )
    return index + page + 1
  }

export const getFirstUnansweredPersonality =
  ({ answers, questions }) =>
  page => {
    const index = rotate(page + 1, questions).findIndex(
      ({ instrument, key }) => answers?.[instrument]?.[key] == null,
    )
    const found = index >= 0 ? index + page + 1 : index
    return found % questions.length
  }

export const getFirstUnansweredInterest =
  ({ answers, questions }) =>
  page => {
    const index = rotate(page + 1, questions).findIndex(
      ({ key }) => answers?.[key] == null,
    )
    const found = index >= 0 ? index + page + 1 : index
    return found % questions.length
  }

export default pagingSaga
